export const normalizeUom = (uom) => (uom ?? "").toString().toUpperCase().trim();

export const isBlankishUom = (uom) =>
  ["", "_BLANK_", "NONE", "NA", "N/A"].includes(normalizeUom(uom));

export const shouldAlignUomToExpected = ({ expected, current }) =>
  !isBlankishUom(expected) && normalizeUom(current) !== normalizeUom(expected);

export const buildUomMismatchToastMessage = ({ label, expected, got }) =>
  `${label} don't match the HTS unit. Expected '${expected}', but got '${got || "NONE"}'. Updating and saving.`;


